/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.robo-control[_ngcontent-%COMP%]{padding:2px;border-radius:5px}div.robo-control.ng-invalid.ng-touched[_ngcontent-%COMP%]{display:block;background-color:#f8d7da}.extra-padding[_ngcontent-%COMP%]{padding-left:30px}"];
export { styles as styles };
